// simple confirm dialog, with option for a form for simple single item data entry

bq.confirmDialog = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.formId = false;
  this.formEl = false;

};

bq.confirmDialog.DEFAULTS = {
  title: bq.messages.global.dialogConfirmTitle,
  message: 'Are you sure?',
  yes: bq.messages.global.dialogConfirm,
  no: bq.messages.global.dialogCancel,
  form: false,
  formUrl: false,
  formAjax: false,
  inputType: 'text',
  inputPlaceholder: '',
  inputAttributes: {},
  inputName: 'confirm_dialog_input',
  wait: true,
  waitMessage: bq.messages.global.processingRequest,
  viewHandlerConfirm: false,
  viewHandlerMessage: bq.messages.global.processingRequest
};

bq.confirmDialog.prototype = {
  init: function() {
    bq.debug.log("Confirm Dialog : init()", this.$element);

    //set up event catching
    this.$element.on('click', {thiz: this}, this._catchClickEvent);
  },

  createDialog: function() {
    var modalId = this.$element.data('modalId');
    if(!modalId) {
      modalId = 'confirm_dialog_'+( ++bq.helper.uniqueIdCounter );
      this.$element.data('modalId', modalId);
    }

    if (bq.helper.modal.modals[modalId]) {
      bq.helper.modal.modals[modalId].modal('show');
      this._resetStates($(bq.helper.modal.modals[modalId]));
    } else {
      var title = this.options.title,
          content = this._createContent(),
          footer = this._createButtons();

      bq.helper.modal.create(modalId, false, title, content, footer, {});

      if(this.options.formAjax) {
        $(bq.helper.modal.modals[modalId]).find('.dialog-yes-btn').attr(this.options.formAjax);
        bq.global.registerAjaxActions(); //register the ajax action
      } else {
        $(bq.helper.modal.modals[modalId]).find('.dialog-yes-btn').on('click', {thiz:this}, this._catchYesEvent);
      }

        $(bq.helper.modal.modals[modalId]).on('hidden.bs.modal', {thiz:this}, this._catchNoEvent);
    }

  },

  _resetStates: function(formEl) {
    if (formEl.length) {
      formEl.find('input, textarea, select').each(function () {
        if (bq.global.parsley.validationEnabled(this)) {
          bq.global.parsley.destroyElement(this);
          $(this).closest('.form-group')
              .removeClass('has-feedback')
              .removeClass('has-error')
              .find('span.form-control-feedback')
              .remove();
        }
      })
    }
  },

  _createButtons: function() {
    var btns = $();

    if(this.options.no) {
      btns = btns.add($('<button type="button"></button>').attr({
        'class': 'btn btn-default dialog-no-btn',
        'id': 'bqat-btnDialogNo',
        'data-dismiss': 'modal'
      }).html(this.options.no));
    }

    if(this.options.yes) {
      btns = btns.add($('<button type="button"></button>').attr({
        'class': 'btn btn-primary dialog-yes-btn',
        'id': 'bqat-btnDialogYes'
      }).html(this.options.yes));
    }

    return btns;
  },

  _createContent: function() {
    var action;

    if(!this.options.form) {
      return $('<p></p>').html(this.options.message);
    }

    if(this.$element.prop('href')) {
      action = this.$element.prop('href');
    } else if(this.$element.data('formUrl')) { //no href, so check for formUrl data element
      action = this.$element.data('formUrl');
    } else {
      return $('<p></p>').html(this.options.message); //no URL present
    }

    //createform
    this.formId = 'confirm_dialog_form_'+( ++bq.helper.uniqueIdCounter );
    this.formEl = $('<form></form>')
                  .attr({
                    'action': action,
                    'id': this.formId,
                    'class': this.options.message ? 'form-inline bq-form' : 'bq-form',
                    'data-bq': 'validate-form'
                  });
    if (this.options.message) {
      this.formEl.append($('<p></p>').html(this.options.message));
    }
    this.formEl.append(this._createInput());

    return this.formEl;

  },

  _createInput: function() {
    var input;
    var label = '';
    var attributes = $.extend({'placeholder': this.options.inputPlaceholder, 'name': this.options.inputName, 'title': this.options.inputPlaceholder, 'aria-label': this.options.inputName + ' textarea'}, this.options.inputAttributes);
    switch (this.options.inputType) {
      case 'textarea':
        input = $('<textarea></textarea>').attr(attributes);
        break;
      case 'hidden': //must put type while creating it due to ie7 bugs
        input = $('<input type="hidden">').attr(attributes);
        break;
      //case 'select'://notdone
      default:
        input = $('<input type="text">').attr(attributes);
    }

    input.addClass('form-control');

    if (this.options.inputLabel) {
      label = '<label class="element-label' + (attributes.required ? ' required' : '') +'" for="' + attributes.name + '">';
      label += this.options.inputLabel;
      if (attributes.required) {
        label += '<em>*</em>';
      }
      label += '</label>';
    }

    if (this.options.inputType != 'hidden') {
      return $('<div class="form-group form-block ' + (this.options.message ? 'block-single' : '') + '"></div>').append(label, input);
    }

    return input;
  },

  _setLoading: function() {
    if(this.formEl) { this.formEl.hide(); }

    if(!this.options.wait) { return; }

    var isThemeNew = typeof bq.getIsThemeNew === 'function' && bq.getIsThemeNew();
    if (isThemeNew) {
      var confirmModal = bq.helper.modal.modals[this.$element.data('modalId')];
      if (confirmModal) {
        confirmModal.modal('hide');
      }

      if (typeof $.fn.viewHandler === 'function' && !$('body').data('bq.viewHandler')) {
        $('body').viewHandler($('body').data());
      }

      bq.helper.throwEvent('bq.viewhandler.progressmessage', $('body'), {
        message: this.options.waitMessage || this.options.viewHandlerMessage
      });
      return;
    }

    var modalId = this.$element.data('modalId');

    var modal = $('#'+modalId);
    modal.find('.modal-footer, .modal-header, .modal-body p').hide();
    modal.find('.modal-body').append('<p/>').html(this.options.waitMessage);
  },

  _validateForm: function() {
    if(this.formEl && this.formEl.data('Parsley')) {
      return this.formEl.parsley().validate();
    }

    return true;
  },

  _processClickEvent: function() {
    if(!this.options.form) {
        var target = this.options.target ? this.options.target : this.$element.prop('href');
        var isThemeNew = bq.getIsThemeNew();
        var useViewHandlerConfirm = this.options.viewHandlerConfirm && isThemeNew;

        if (useViewHandlerConfirm) {
          var confirmModal = bq.helper.modal.modals[this.$element.data('modalId')];
          if (confirmModal) {
            confirmModal.modal('hide');
          }

          bq.helper.throwEvent('bq.viewhandler.progressmessage', 'data-view-handler', {
            message: this.options.viewHandlerMessage
          });

          setTimeout(function() {
            window.location = target;
          }, 50);
        } else if (
          !this.$element.hasClass('trigger-view-handler-on-click') ||
          !isThemeNew
        ) {
          this._setLoading();
          window.location = target;
        } else {
          var modal = bq.helper.modal.modals[this.$element.data('modalId')];
          if (modal) {
            modal.modal('hide');
          }
          bq.helper.throwEvent('bq.viewhandler.progressmessage', $('body'), {
            message: bq.messages.global.loadingLongWait
          });
          setTimeout(function() {
            window.location = target;
          }, 50);
        }

        return false;
    }

    if(!this._validateForm()) { return false; }

    if(!this.options.formAjax) { // not an ajax form lets just submit it
      this.formEl.submit();
      this._setLoading();
    }

    //its an ajax form... not done


  },

  _catchNoEvent: function(e) {
    var $this = e.data.thiz;
    if ($this.formEl.length) {
      $this.formEl.trigger('reset');
      $this.formEl.find('[data-validate-maxlength]').each(function() {
        $(this).data('validate-maxlength')
          && $(this).data('bq.charLimit')
          && $(this).data('bq.charLimit').updateRemaining($(this).data('validate-maxlength'));
      });
    }
  },

  _catchYesEvent: function(e) {
    var $this = e.data.thiz,
        el = $this.$element;

    if ($this.formEl.length) {
      $this.formEl.find('input, textarea, select').each(function() {
        if (!bq.global.parsley.validationEnabled(this)) {
          bq.global.parsley.setupSingle(this);
        }
        bq.global.parsley.validate(this);
      })
      if ($this.formEl.find('.has-error').length > 0) {
        return;
      }
    }

    if (el.data('action') || el.data('action-onclick')) {

      if(el.data('action-onclick')) {

        var $btnActionOnclick = $("<button/>").attr('onclick', el.data('action-onclick'));

        $('body').append($btnActionOnclick);
        $btnActionOnclick.click().remove();

        if(!el.data.wait) {
          bq.helper.modal.modals[el.data('modalId')].modal('hide');
        }

      } else {

        el.off('click', $this._catchClickEvent);
        bq.helper.modal.modals[el.data('modalId')].modal('hide');
        el.removeData('bq');
        el.removeAttr('data-bq');
        el.click();

      }

    } else {
      $this._processClickEvent();
    }
  },

  _catchClickEvent: function(e) {
    e.preventDefault();
    var $this = e.data.thiz;
    $this.createDialog();
  }


};

// Confirm Dialog PLUGIN DEFINITION
// =======================

var confirmDialogold = $.fn.confirmDialog;

$.fn.confirmDialog = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.confirmDialog');
    var options = $.extend({}, bq.confirmDialog.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.confirmDialog', (data = new bq.confirmDialog(this, options))); }
    data.init();
  });
};

$.fn.confirmDialog.Constructor = bq.confirmDialog;

// Confirm Dialog NO CONFLICT
// =================

$.fn.confirmDialog.noConflict = function () {
  $.fn.confirmDialog = confirmDialogold;
  return this;
};

// Confirm Dialog DATA-API
// ==============
bq.confirmDialogInit = function() {
    $('[data-bq="confirm-dialog"]').each(function() {
      var el = $(this);
      if(el.data('bq.confirmDialog')) { return; }
      el.confirmDialog(el.data());
    });
};

bq.init.push(bq.confirmDialogInit);

var approversUpdatedId;
$(document).bind('bq.approvers.updated', function() {
    clearTimeout(approversUpdatedId);
    approversUpdatedId = setTimeout(bq.confirmDialogInit, 500);
});
